<template>
  <div class="radio-table-comp">
    <div class="RT-titleText">
      <p>{{ titleText }}</p>
      <ul v-if="listOn">
        <li
          v-for="(paragraph, index) in list"
          :key="`${$route.name}_rtTextList-${id}_${index}`"
        >
          {{ paragraph }}
        </li>
      </ul>
    </div>
    <div class="RT-Table">
      <table class="table">
        <thead>
          <tr>
            <td></td>
            <td
              v-for="(answer, index) in answers"
              :key="`${$route.name}_radioTableQ-${id}_${index}`"
            >
              {{ answer }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(question, index) in questions"
            :key="`${$route.name}_radioTableA-${id}_${index}`"
          >
            <td>{{ question }}</td>
            <td
              v-for="(check, j) in answers"
              :key="`${$route.name}_radioTableA-${id}_${index}_radio${j}`"
            >
              <input
                type="radio"
                :value="check"
                v-model="tableAnswers[index]"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="RT-Column">
      <div
        v-for="(question, index) in questions"
        :key="`${$route.name}_radioTableCol-${id}_${index}`"
        class="RT-radioCol"
      >
        <p>{{ question }}</p>
        <div
          v-for="(answer, j) in answers"
          :key="`${$route.name}_radioTableColA-${id}_${j}`"
        >
          <input type="radio" :value="answer" v-model="tableAnswers[index]" />{{
            answer
          }}
        </div>
      </div>
    </div>
    <div v-if="commentBox" class="RT-commentbox">
      <p>{{ commentBoxText }}</p>
      <textarea v-model="tableAnswers[questions.length]"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioButtonTable",
  props: {
    id: {
      type: String,
      required: true,
    },
    titleText: {
      type: String,
      default: "Radio button table",
    },
    list: {
      type: Array,
      default() {
        return ["List paragraph for Radio Table"];
      },
    },
    answers: {
      type: Array,
      default() {
        return ["answer1", "answer2", "answer3", "answer4", "answer5"];
      },
    },
    questions: {
      type: Array,
      default() {
        return ["question1", "question2", "question3"];
      },
    },
    commentBox: {
      type: Boolean,
      default: true,
    },
    commentBoxText: {
      type: String,
      default: "Comment box header here",
    },
    currentInput: {
      type: Array,
      default() {
        return [];
      },
    },
    listOn: {
      type: Boolean,
      default: true,
    },
  },
  beforeMount() {
    this.tableAnswers = this.currentInput;
  },
  data() {
    return {
      tableAnswers: [],
    };
  },
};
</script>

<style lang="scss">
.radio-table-comp {
  .RT-Column {
    display: none;
    @media screen and (max-width: 800px) {
      display: block;
    }

    .RT-radioCol {
      margin-bottom: 30px;

      [type="radio"]:not(:checked) {
        position: static !important;
        opacity: 1 !important;
      }

      [type="radio"]:checked {
        position: static !important;
        opacity: 1 !important;
      }

      div {
        margin-bottom: 10px;
      }
    }
  }

  .RT-Table {
    color: #15243c;

    @media screen and (max-width: 800px) {
      display: none;
    }

    thead {
      border-bottom: none;
    }

    td {
      text-align: center;

      [type="radio"]:not(:checked) {
        position: static !important;
        opacity: 1 !important;
      }

      [type="radio"]:checked {
        position: static !important;
        opacity: 1 !important;
      }

      &:first-child {
        border-left: none !important;
        text-align: left;
      }

      &:last-child {
        border-right: none !important;
      }
    }

    tr {
      &:first-child {
        td {
          border-top: none !important;
        }
      }

      &:nth-child(odd) {
      }
    }

    thead {
      tr {
        background: #bfe0f7 !important;
      }
    }
  }

  .RT-titleText {
    p {
      color: #15243c;
      font-weight: bold;
    }
  }

  .RT-commentbox {
    textarea {
      width: 70%;
      border: 2px solid #27606c;
      border-radius: 8px;
      outline: none;
      padding: 16px;
      margin-top: 4px;

      @media screen and (max-width: 992px) {
        width: 90%;
        padding: 0;
      }
    }
  }
}
</style>